function getSrc(el) {
    let rawSrc = (el.attr('src') ? el.attr('src') : el.attr('data-src'));
    return rawSrc.replace(/(?=[() ])/g, '\\');
}


$(document).ready(function () {

    $('.dynamicPageContainer .sectionHeading').each(function () {
        const text = $(this).text();
        // CUSTOMIZED TITLES
        if (text === '{hero-banner}') {
            $(body).addClass('heroBanner')
            $(this).parent('.entityContainerRow').addClass('customized-title');
            $('<div class="banner"></div>').insertBefore('.content');

            $('.customized-title img').each(function () {
                let heroPath = $(this);
                heroPath = getSrc(heroPath);
                $('.banner').css('background-image', `url("${heroPath}")`);
                $(this).remove();
            });
            let title = $(this).parent().find('.moduleTitle span').text();
            $('.banner').append(`<div class="banner-content"><div class="banner-title">${title}</div></div>`)
            $(this).parent().remove();

        }
    })
})